The formatted name of the candidate.
